import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

export interface IInputGroup {
  code: number;
  guid: string;
  icon: string;
  image: string;
  title: string;
  title_description: string | null;
}
export interface IGetMyStoreInputGroupsParams {
  only_lendtech?: boolean;
  status?: 'published' | 'pending' | 'rejected' | 'expired';
}

const getMyStoreInputGroups = async (params: IGetMyStoreInputGroupsParams) => {
  const {data}: {data: IInputGroup[]} = await request.get(
    `/api/v2/store/my-store-input-group`,
    {params: cleanFields(params)},
  );
  return data;
};

export default getMyStoreInputGroups;
